// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1HGP9","content":"styles_content__2L72z","selectAll":"styles_selectAll__-FQgd"};